import { render, staticRenderFns } from "./readercomments.html?vue&type=template&id=154bd00e&scoped=true&"
import script from "./readercomments.js?vue&type=script&lang=js&"
export * from "./readercomments.js?vue&type=script&lang=js&"
import style0 from "./readercomments.sass?vue&type=style&index=0&id=154bd00e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154bd00e",
  null
  
)

component.options.__file = "readercomments.vue"
export default component.exports